import React from "react";
import { Link } from "react-router-dom";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

export default function About() {
  return (
    <MarketingPage
      seo={{
        title: "About — The team building human-in-the-loop AI outreach",
        description:
          "Collavue is building the AI lead discovery and reply layer for B2B teams. Meet the team and read why we're convinced public conversations are the next great pipeline channel.",
        path: "/about",
        keywords: "about Collavue, Collavue team, AI lead generation company, social listening startup",
      }}
    >
      <PageHero
        eyebrow="About"
        title="Public conversations are the new"
        italicWord="pipeline channel."
        description="Collavue is the AI lead discovery and reply layer for B2B teams who'd rather meet customers where they're already complaining than buy ads to interrupt them."
      />

      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-4xl mx-auto px-6 py-20 prose prose-slate">
          <h2 className="font-display text-3xl text-[#0a1736] font-semibold">Our story</h2>
          <p className="text-[#5a6478] mt-4 leading-relaxed">
            We started Collavue because we kept watching SaaS founders manually scroll X (Twitter),
            LinkedIn, and Reddit for buying signals — copy-pasting links into a Notion doc, drafting replies
            in a separate window, and forgetting to follow up. We thought: this should be a
            product, not a chore.
          </p>
          <p className="text-[#5a6478] mt-4 leading-relaxed">
            Collavue automates the boring half — discovery, scoring, drafting — and keeps the
            interesting half human. You stay in charge of every reply that goes out.
          </p>
          <h2 className="font-display text-3xl text-[#0a1736] font-semibold mt-12">Get in touch</h2>
          <p className="text-[#5a6478] mt-4 leading-relaxed">
            Press, partnerships, or just want to chat?{" "}
            <Link to="/press" className="text-[#2d5bff] hover:underline">See our press page</Link>{" "}
            or email <a className="text-[#2d5bff] hover:underline" href="mailto:hello@collavue.com">hello@collavue.com</a>.
          </p>
        </div>
      </section>
    </MarketingPage>
  );
}
